<template>
    <div class="mb-4">
        {{ translate("Select Themes") }}

        <div class="form-group mt-4 row">
            <div class="col-xl-12 dm-checkbox-email-options checkbox-list">
                <label
                    class="checkbox"
                    v-for="theme in themes"
                    :key="'theme-' + theme.id"
                >
                    <input
                        type="checkbox"
                        :value="theme.id"
                        v-model="submission.themes_ids"
                        @change="saveSubmission()"
                    />
                    <span></span>{{ theme.name }}
                </label>
            </div>
        </div>
    </div>

    <div class="mb-8">
        {{ translate("Other Themes") }}
        <input
            class="form-control dm-other-themes"
            v-model="submission.other_themes"
            @change="saveSubmission()"
        />
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState, mapWritableState, mapActions } from "pinia";

export default {
    props: ["themes"],

    computed: {
        ...mapState(useSubmissionWizardStore, ["matching_themes"]),
        ...mapWritableState(useSubmissionWizardStore, ["submission"]),
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["saveSubmission"]),
    },
};
</script>
